var _linearGradient, _namedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 384 512",
    id: "svg51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs55"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2179"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00aaff",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop2175"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff7f7f",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop2177"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    collect: "always",
    xlinkHref: "#linearGradient2179",
    id: "linearGradient2181",
    x1: 190.53882,
    y1: 512.5625,
    x2: 190.53882,
    y2: 0.36148363,
    gradientUnits: "userSpaceOnUse"
  }))), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview53",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    pageshadow: 2,
    pageopacity: 0,
    pagecheckerboard: 0,
    showgrid: "false",
    zoom: 1.5546875,
    cx: 58.532663,
    cy: 255.35678,
    "window-width": 1920,
    "window-height": 1011,
    "window-x": 0,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg51"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 240.5,224 H 352 c 13.3,0 25.3,8.3 29.1,20.7 5.5,12.5 2,26.6 -8,35.4 l -256,224 c -11.3,9.8 -27.83,10.6 -39.91,1.8 C 65.1,497.1 60.7,481.1 66.59,467.4 L 143.5,288 H 31.1 C 18.67,288 6.733,279.7 2.044,267.3 -2.645,254.8 0.8944,240.7 10.93,231.9 L 266.9,7.918 c 11.3,-9.838 27.8,-10.587 39.9,-1.804 12.1,8.786 16.5,24.756 10.6,38.496 z",
    id: "path49",
    style: {
      mixBlendMode: "normal",
      fill: "url(#linearGradient2181)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltGradient);
export default __webpack_public_path__ + "static/media/bolt-gradient.8b4e4d2d91505c577e7b278d49680372.svg";
export { ForwardRef as ReactComponent };